<template>
    <div class="type_area customer_home">
        <!-- 公共侧边栏 -->
        <div class="sidebar_box">
            <!-- <div class="sidebar_item" :class="{active: currentUrl == item.url}" @click="pageJump(item.url,item.name)" v-for="item in sidebarList" :key="item.name">{{item.name}}</div> -->
            <el-menu style="width:200px;" class="el-menu-vertical-demo" :unique-opened="true" :default-active="defaultActive" text-color="#999999" active-text-color="#1A9DFF">
                <el-submenu :index="''+index" v-for="(item,index) in sidebarList" :key="index">
                    <template slot="title">
                        <span style="font-size: 16px !important;color: #333333 !important">{{item.name}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-for="(items,indexs) in item.childen" @click="pageJump(items.url,items.name)" :key="indexs" :index="index+'-'+indexs">
                            <span style="font-size: 16px;">{{items.name}}</span>
                        </el-menu-item>
                        <!-- <el-menu-item index="1-2">选项2</el-menu-item> -->
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </div>

        <!-- 主要区域容器 -->
        <div class="customer_main">
            <div class="bread_box">
                <span class="index" @click="$router.push('/')">首页</span>
                <span> / 个人中心 / {{currentName}}</span>
            </div>
            <div>
                <router-view></router-view>
            </div>
        </div>
        <!-- 主要区域容器END -->
    </div>
</template>

<script>

export default {
    name: 'PersonalHome',
    data() {
        return {
            currentUrl: this.$route.path,
            currentName: '',
            defaultActive: '0-0',
            sidebarList: [
                {
                    name: '订单信息',
                    childen: [
                        {
                            name: '我的订单',
                            url: '/personal/myOrder',
                            index: '0-0'
                        },
                        {
                            name: '待客户经理审核',
                            url: '/personal/auditingOrder',
                            index: '0-1'
                        }, {
                            name: '收货地址',
                            url: '/personal/myAddress',
                            index: '0-2'
                        }, {
                            name: '采购历史',
                            url: '/personal/purchaseHistory',
                            index: '0-3'
                        },
                    ]
                },
                {
                    name: '资料中心',
                    childen: [
                        {
                            name: '首营资料',
                            url: '/personal/firstData',
                            index: '1-0'
                        }, {
                            name: '药检报告',
                            url: '/personal/testReport',
                            index: '1-1'
                        },
                        {
                            name: '发票列表',
                            url: '/personal/myInvoice',
                            index: '1-2'
                        }, {
                            name: '付款委托书',
                            url: '/personal/payBook',
                            index: '1-3'
                        },
                    ]
                },
                {
                    name: '账户信息',
                    childen: [
                        {
                            name: '我的收藏',
                            url: '/personal/myFavorites',
                            index: '2-0'
                        },
                        {
                            name: '我的优惠券',
                            url: '/personal/myCoupon',
                            index: '2-1'
                        },

                        {
                            name: '我的留言',
                            url: '/personal/myMessage',
                            index: '2-2'
                        },

                        {
                            name: '账号信息',
                            url: '/personal/accountInfo',
                            index: '2-3'
                        },

                        {
                            name: '修改密码',
                            url: '/personal/changePassword',
                            index: '2-4'
                        },
                        {
                            name: '安全退出',
                            url: '',
                            index: '2-5'
                        },
                    ]
                },





            ],
        };
    },
    watch: {
        // 监听路由对象的变化
        '$route'(to, from) {
          
            // 当路由发生变化时，你可以在这里处理你的逻辑
            this.currentUrl = this.$route.path
            
            this.sidebarList.forEach(item => {
                item.childen.forEach(items => {
                  if (items.url == this.currentUrl) {
                    this.currentName = items.name
                    this.defaultActive = items.index
                  }
                })
            })
            // 你可以在这里根据路由做出相应的处理
        }
    },
    mounted() {
        this.currentUrl = this.$route.path
        this.sidebarList.forEach(item => {
            item.childen.forEach(items => {
              if (items.url == this.currentUrl) {
                    this.currentName = items.name
                    this.defaultActive = items.index
                  }
                })
        })
    },
    methods: {
        // 页面跳转
        pageJump(url, name) {
            if (name == '安全退出') {
                this.$confirm('此操作将退出登录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.visitorLogout().then((res) => {
                        if (res.data.code === 200) {
                            localStorage.removeItem('roleFrist')
                            localStorage.removeItem('roleNumber')
                            this.$store.commit('quit')
                            this.$router.push('/login')
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'warning',
                        message: '已取消退出'
                    });
                });

            } else {
                this.currentName = name
                this.currentUrl = url
                this.$router.push(url)
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.customer_home {
    display: flex;
    align-items: flex-start;
    margin-top: 18px;

    .sidebar_box {
        flex-shrink: 0;
        border-radius: 2px;
        overflow: hidden;
        margin-right: 20px;

        .sidebar_item {
            width: 160px;
            box-sizing: border-box;
            padding: 12px 24px;
            background: #fff;
            font-size: 16px;
            color: #333333;
            cursor: pointer;

            &.active {
                background: #e7f5ff;
                color: #1a9dff;
            }

            &:hover {
                color: #1a9dff;
            }
        }
    }

    .customer_main {
        width: calc(100% - 180px);
        flex: 1;

        .bread_box {
            margin-bottom: 12px;
            font-size: 16px;
            color: #666666;
            padding-top: 9px;

            .index {
                &:hover {
                    color: #1a9dff;
                    transition: 0.3;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>